import {PanelTitleFn} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';
import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIcons, WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {Spinner, SpinnerSize} from '@mintdata-wsp/common/components/spinner/Spinner';
import {DebugKind} from '@mintdata-wsp/wsp/ui/views/visualDesigner/panels/debugData/DebugDataPanel';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DebugDataMessageView.less');
const cx = classnames.bind(styles);

export interface DebugDataMessageViewProps
{
    kind:DebugKind;
    panelTitle:PanelTitleFn;
    state:DebugDataState;
}

export enum DebugDataState
{
    DesignNeverStarted,
    DesignStartedWaitingForData,
    NoDataForCurrentBlockOrWire,
    VisualDataExists,
    Stopped_StaleVisualDataExists,
    Stopped_FlowErrorsExist
}

@observer
export class DebugDataMessageView extends React.Component<DebugDataMessageViewProps, any>
{
    private _renderVisualPart()
    {
        const {state} = this.props;

        switch( state )
        {
            case DebugDataState.DesignNeverStarted:
                return <WSPIcon className={cx('dataFountainIcon')}
                                name={WSPIcons.common.placeholders.DataFountain}
                                size={WSPIconSize.xlarge_80}/>;
            case DebugDataState.DesignStartedWaitingForData:
                return <Spinner size={SpinnerSize.Large_64}/>;
            case DebugDataState.NoDataForCurrentBlockOrWire:
            case DebugDataState.Stopped_StaleVisualDataExists:
            case DebugDataState.Stopped_FlowErrorsExist:
                return <WSPIcon name={WSPIcons.common.placeholders.DataFountain}
                                size={WSPIconSize.xlarge_80} className={cx('dataFountainIcon', 'dimIcon' )}/>;
        }
    }

    private _renderMessage(line1:any, line2:any)
    {
        return  <Column className={cx('lines')}>
                    <div className={cx('line1')}>{line1}</div>
                    <div className={cx('line2')}>{line2}</div>
                </Column>;
    }

    @bind
    private _onStartDesignClicked()
    {
        // controllers.ui.simulation.startSimulation();
    }

    private _renderMessagePart()
    {
        const {state} = this.props;

        /**
         DesignNeverStarted,
         DesignStartedWaitingForData,
         NoDataForCurrentBlockOrWire,
         VisualDataExists,
         Stopped_StaleVisualDataExists,
         Stopped_FlowErrorsExist
         */

        switch( state )
        {
            case DebugDataState.DesignNeverStarted:
                return this._renderMessage
                        (
                            <span><a onClick={this._onStartDesignClicked}>Start the design</a> to see live data</span>,
                            'Live data will appear here once the design is running'
                        );
            case DebugDataState.DesignStartedWaitingForData:
                return this._renderMessage
                (
                    <span>Design starting...</span>,
                    'Live data will appear here shortly'
                );
            case DebugDataState.NoDataForCurrentBlockOrWire:
                return this._renderMessage
                (
                    <span>Data has not arrived for {this.props.panelTitle()}</span>,
                    'Please check the connection(s) to this block or wire'
                );
            case DebugDataState.VisualDataExists:
            case DebugDataState.Stopped_StaleVisualDataExists:
                return null;
            case DebugDataState.Stopped_FlowErrorsExist:
                return this._renderMessage
                (
                    <span>Data has not arrived for {this.props.panelTitle()}</span>,
                    (this.props.kind === DebugKind.Wire)?
                        `Please check the blocks connected to this wire`
                        :
                        `Please check the wires connected to this block`
                );
        }

        console.log(`Error: unexpected state in DebugDataMessageView::_renderMessagePart(): ${state}`, state);
        return null;
    }

    render()
    {
        return  <Column className={cx('debugDataMessageView')}>
                    <Row className={cx('topSpacer')}/>

                    <Row className={cx('messageContent')}>
                        <Column className={cx('icon')}>
                            {this._renderVisualPart()}
                        </Column>
                        {this._renderMessagePart()}
                    </Row>

                    <Row className={cx('bottomSpacer')}/>
                </Column>
    }
}
